<template>
  <div
    class="sa-rep-tabs"
    role="tablist"
    aria-label="Tipos de relatório"
    @keydown="onKeydown"
  >
    <button
      v-for="(tab, index) in tabs"
      :id="`report-tab-${tab.id}`"
      :key="tab.id"
      type="button"
      role="tab"
      class="sa-rep-tabs__tab"
      :class="{ active: modelValue === tab.id }"
      :aria-selected="modelValue === tab.id"
      :tabindex="modelValue === tab.id ? 0 : -1"
      :aria-controls="`report-panel-${tab.id}`"
      @click="$emit('update:modelValue', tab.id)"
      ref="tabButtons"
      :data-index="index"
    >
      {{ tab.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'ReportsTabs',
  props: {
    modelValue: { type: String, required: true },
    tabs: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:modelValue'],
  methods: {
    onKeydown(event) {
      const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (!keys.includes(event.key)) return;

      event.preventDefault();
      const current = this.tabs.findIndex((tab) => tab.id === this.modelValue);
      if (current < 0) return;

      let next = current;
      if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = this.tabs.length - 1;

      const tab = this.tabs[next];
      if (!tab) return;
      this.$emit('update:modelValue', tab.id);
      this.$nextTick(() => {
        const buttons = this.$refs.tabButtons;
        const list = Array.isArray(buttons) ? buttons : [buttons];
        list[next]?.focus?.();
      });
    },
  },
};
</script>

<style scoped>
.sa-rep-tabs {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  padding: 0.25rem;
  background: #f3f4f8;
  border-radius: 10px;
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.sa-rep-tabs__tab {
  appearance: none;
  border: 0;
  background: transparent;
  color: var(--dashboard-text, #191c24);
  font-size: 0.8125rem;
  font-weight: 600;
  padding: 0.5rem 0.95rem;
  border-radius: 8px;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 160ms ease, color 160ms ease;
}

.sa-rep-tabs__tab:hover {
  background: rgba(255, 255, 255, 0.7);
}

.sa-rep-tabs__tab.active {
  background: var(--dashboard-primary, #250891);
  color: #fff;
}

.sa-rep-tabs__tab:focus-visible {
  outline: 2px solid var(--dashboard-primary, #250891);
  outline-offset: 2px;
}
</style>
